import FrequentlyAskedQuestion from "@components/FrequentlyAskedQuestion"
import { useTranslation } from "react-i18next"

export default function FrequentlyAskedQuestions() {
  const { t } = useTranslation()

  return (
    <div className="space-y-4">
      <h2 className="heading">{t("components.faq.heading")}</h2>

      <div className="space-y-4">
        <FrequentlyAskedQuestion
          text={t("components.faq.whyFilterlyText")}
          title={t("components.faq.whyFilterlyTitle")}
        />
        <FrequentlyAskedQuestion
          text={t("components.faq.howToGetAccessText")}
          title={t("components.faq.howToGetAccessTitle")}
        />
        <FrequentlyAskedQuestion
          text={t("components.faq.howToCancelText")}
          title={t("components.faq.howToCancelTitle")}
        />
      </div>
    </div>
  )
}
